let map: google.maps.Map
export async function initMap() {
    const mapEl = document.querySelector('[data-map-holder]') as HTMLElement
    if (!mapEl) return

    const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;

    const offerMap = mapEl.dataset.mapHolder !== 'testimonials'
    const pathJson = mapEl.dataset.path
    const pathPoints: ({lat: number, lng: number} | null)[] = pathJson ? JSON.parse(pathJson) : []
    let mapCenter: google.maps.LatLngLiteral,
        zoom: number

    if (offerMap) {
        if (mapEl.dataset.lat && mapEl.dataset.lng) {
            mapCenter = { lat: parseFloat(mapEl.dataset.lat), lng: parseFloat(mapEl.dataset.lng) }
        } else {
            const first = pathPoints.find((p): p is {lat: number, lng: number} => p !== null)
            mapCenter = first ?? { lat: 50.04213569336836, lng: 14.462417253071795 }
        }
        zoom = 15
    } else {
        mapCenter = { lat: 50.04213569336836, lng: 14.462417253071795 }
        zoom = 12
    }

    map = new Map(mapEl, {
        center: mapCenter,
        zoom: zoom,
        zoomControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        styles: [
            {
                "featureType": "all",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry",
                "stylers": [
                    {
                        "weight": "0.5"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "lightness": "-50"
                    },
                    {
                        "saturation": "-50"
                    }
                ]
            },
            {
                "featureType": "administrative.neighborhood",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "hue": "#009aff"
                    },
                    {
                        "saturation": "25"
                    },
                    {
                        "lightness": "0"
                    },
                    {
                        "visibility": "simplified"
                    },
                    {
                        "gamma": "1"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "saturation": "0"
                    },
                    {
                        "lightness": "100"
                    },
                    {
                        "gamma": "2.31"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "simplified"
                    },
                    {
                        "lightness": "20"
                    },
                    {
                        "gamma": "1"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "saturation": "-100"
                    },
                    {
                        "lightness": "-100"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape.man_made",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    },
                    {
                        "saturation": "-100"
                    },
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "lightness": "0"
                    },
                    {
                        "saturation": "45"
                    },
                    {
                        "gamma": "4.24"
                    },
                    {
                        "visibility": "simplified"
                    },
                    {
                        "hue": "#00ff90"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "saturation": "-100"
                    },
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "simplified"
                    },
                    {
                        "color": "#666666"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "saturation": "-25"
                    }
                ]
            },
            {
                "featureType": "transit.line",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "transit.station.airport",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": "50"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "lightness": "50"
                    },
                    {
                        "gamma": ".75"
                    },
                    {
                        "saturation": "-50"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            }
        ]
    });

    if (offerMap) {
        if (pathPoints.length) {
            const bounds = new google.maps.LatLngBounds()
            let segment: google.maps.LatLngLiteral[] = []

            const flush = () => {
                if (segment.length >= 2) {
                    new google.maps.Polyline({
                        path: segment,
                        map,
                        strokeColor: '#31325A',
                        strokeWeight: 5,
                        strokeOpacity: 0.85,
                    })
                    segment.forEach(p => bounds.extend(p))
                }
                segment = []
            }

            for (const p of pathPoints) {
                if (p === null) flush()
                else segment.push(p)
            }
            flush()

            if (!bounds.isEmpty()) map.fitBounds(bounds, 40)
        } else {
            const marker = new google.maps.Marker({
                position: mapCenter,
                //icon: `${themeRoot}/resources/images/map-logo.svg`,
                map: map
            });
        }
    } else {
        const layer = new google.maps.KmlLayer({
            url: "https://www.google.com/maps/d/kml?mid=1RtfFzzyQRjIXNMgwgTCLpkiOmNM",
            map: map,
            preserveViewport: true
        })
    }

    map.addListener("tilesloaded", () => mapEl.classList.remove('is-loading'))
    //map.addListener("click", (mapsMouseEvent) => console.log(mapsMouseEvent.latLng.toJSON()));
}